import type { RadarSession } from './types';

export type RadarUsageMetric = 'companies' | 'emails' | 'monitoring' | 'drafts';
export type RadarUsageBalance = { limit: number; used: number; reserved: number; remaining: number };
export type RadarOutcomeUsage = {
  mode: 'outcome_trial' | 'outcome_subscription';
  starts_at: string;
  expires_at: string;
  status: 'active' | 'expired';
  balances: Record<RadarUsageMetric, RadarUsageBalance>;
  feedback?: { completed: number; required: number; grant_status: 'available' | 'locked' | 'granted' };
  rewards?: {id:string;amount:number;status:'granted'|'available'|'locked'}[];
  billing?: {plan_id:string;period_key:string|null;currency?:string;amount_minor?:number;interval?:string;
    subscription_status:string;cancel_at_period_end:boolean;has_customer:boolean;monitoring_interval_days:number};
};

export type RadarBillingConnection = {token:string;workspaceId:string;onUsageChanged:(usage:RadarOutcomeUsage)=>void;
  /** Stripe uses the same return URL for payment, cancellation and Portal. Never a receipt. */
  returning?:boolean;onReturnDismissed?:()=>void};

export type RadarUsageContext = {
  access?: RadarSession['access'] | null;
  searchesRemaining?: number;
  monitoring?: { active_count: number; limit: number };
  outcome?: RadarOutcomeUsage | null;
  refreshFailed?: boolean;
  billing?: RadarBillingConnection;
};

// An absent outcome contract is never a grant of the illustrative trial plan.
export function balanceState(balance: RadarUsageBalance): 'normal' | 'low' | 'empty' {
  if (balance.remaining <= 0) return 'empty';
  return balance.limit > 0 && balance.remaining / balance.limit <= .2 ? 'low' : 'normal';
}
